import { useState } from 'react';
import * as XLSX from 'xlsx';

const useExcelToJson = () => {
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const excelFileToJson = (file, onCompleteLoad) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      setLoading(true);
      const data = e.target.result;
      const workbook = XLSX.read(data, {
        type: 'binary',
        cellDates: true,
      });

      const items = workbook.SheetNames.map(function (sheetName) {
        // Here is your object
        const XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

        return {
          sheetName: sheetName,
          items: XL_row_object,
        };
      });

      onCompleteLoad(items);

      setData(items);

      setCompleted(true);
      setLoading(false);
    };

    reader.onerror = function (ex) {
      setError(ex);
      setHasError(true);
      console.log(ex);
    };

    reader.readAsBinaryString(file);
  };

  return {
    loading,
    hasError,
    error,
    completed,
    data,
    excelFileToJson,
  };
};

export default useExcelToJson;
